module.exports = __webpack_public_path__ + "img/googlepay.89bf47dd.svg";